import { R } from "helpers/models";

export default (key: string, rule: R): string => {
  // if (key === "Negligible") {
  //   return "#FFF";
  // }
  if (key === "Outside" || key === "No Observation") {
    return "#f2f2f2";
  }
  if (key === "" || key === "No Data" || key === "No_Data") {
    return "grey";
  }
  if (rule[key]) {
    return rule[key];
  }
  if (
    key === "5 years" ||
    key === "10 years" ||
    key === "20 years" ||
    key === "50 years"
  ) {
    return rule["≤50 years"];
  } else if (key === "1000 years") {
    return rule["≥1000 years"];
  }
  return "";
};
